import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { auth, user, post, address, role, menu } from './reducers'
export const getReducers = (history) => {
    const reducers = {
        auth,
        user,
        post,
        role,
        address,
        menu,
        router: connectRouter(history)
    }
    return combineReducers(reducers);
}
export default getReducers;